import mitt, { Emitter } from 'mitt'
import { PostElementsBody } from '/@/types/mapLayer'

export interface MapElementDraftCreatedPayload {
  element: PostElementsBody
  overlay: any
}

type Events = {
  deviceUpgrade: any; // 设备升级
  deviceLogUploadProgress: any // 设备日志上传
  flightTaskWs: any // 机场任务消息
  flightRecordWs: any // 飞行记录摘要更新
  gMapReady: void
  droneControlWs: any // 飞行指令信息
  droneControlMqttInfo: any // drc 链路通知
  speakerPlayProgress: any // AS1 喊话播放进度
  speakerState: any // AS1 喊话器状态上报
  flightAreasDroneLocationWs: any
  flightAreasSyncProgressWs: any
  flightAreasUpdateWs: any
  tsaLocateDock: { dockSn: string, dockName?: string }
  mapElementDraftCreated: MapElementDraftCreatedPayload
  inspectionWs: any
};

const emitter: Emitter<Events> = mitt<Events>()

export default emitter
